import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface Currency {
  id?: string
  name: string
  code: string
  iso_code: string
  symbol: string
  decimals?: number
  updated_at: string
}

export async function getCurrencies(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = []
  if (search) {
    where.push(`CONCAT(name,code,iso_code) ILIKE '%${search}%'`)
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = ['order by code asc'])
  // result
  const response: any = await getData({
    tables: ['pg_currencies'],
    fields: ['id', 'code', 'name', 'iso_code', 'symbol', 'updated_at'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}

export async function getCurrency(id: string): Promise<Currency> {
  const data = await getData<any>({
    tables: ['pg_currencies'],
    fields: [
      'id',
      'code',
      'decimals',
      'iso_code',
      'name',
      'symbol',
      'custom_fields as custom'
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createCurrency(data: Currency): Promise<boolean> {
  const response: any = await http.post('general/currencies/', {
    name: data.name,
    code: data.code.toString(),
    iso_code: data.iso_code,
    symbol: data.symbol,
    decimals: data.decimals,
    custom_fields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateCurrency(
  data: Currency,
  id: string
): Promise<boolean> {
  const response: any = await http.put(`general/currencies/${id}`, {
    name: data.name,
    code: data.code.toString(),
    iso_code: data.iso_code,
    symbol: data.symbol,
    decimals: data.decimals,
    custom_fields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteCurrency(id: string): Promise<boolean> {
  const response: any = await http.delete(`general/currencies/${id}`)
  if (response?.data?.data?.error) {
    return false
  }
  return true
}
